import { render } from "./ReviewUserTemplate.vue?vue&type=template&id=3006deb5"
import script from "./ReviewUserTemplate.vue?vue&type=script&lang=js"
export * from "./ReviewUserTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__